export default function () {
  const role = this.$store.state.user.roles[0] || null

  if (role === 'ROLE_CUSTOMER') {
    this.$router.push('/orders')
  }
}
